module.exports = __webpack_public_path__ + "static/media/wow.8727e1ac.png";